if (!customElements.get('product-sticky-cart-bar')) {
  customElements.define(
    'product-sticky-cart-bar',
    class ProductStickyCartBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-add]');
        this.buttonLabel = this.querySelector('.product-sticky-cart-bar__button-label');
        this.bindFormTargets();

        this.onButtonClick = this.onButtonClick.bind(this);
        this.button?.addEventListener('click', this.onButtonClick);

        this.observeMainSubmit();

        document.body.classList.add('has-product-sticky-cart-bar');
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onButtonClick);
        this.submitObserver?.disconnect();
        document.body.classList.remove('has-product-sticky-cart-bar');
      }

      bindFormTargets() {
        this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.form = document.getElementById(this.dataset.productFormId);
        this.productForm =
          this.form?.closest('product-form') ||
          document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      }

      observeMainSubmit() {
        this.submitObserver?.disconnect();
        if (!this.mainSubmit) return;

        this.syncFromMainSubmit();
        this.submitObserver = new MutationObserver(() => this.syncFromMainSubmit());
        this.submitObserver.observe(this.mainSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          subtree: true,
          childList: true,
          characterData: true,
        });
      }

      onButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        if (this.submitting) return;

        this.bindFormTargets();
        this.observeMainSubmit();

        // Prefer the theme product-form submit pipeline when available.
        if (this.form) {
          try {
            if (typeof this.form.requestSubmit === 'function') {
              this.form.requestSubmit(this.mainSubmit || undefined);
              return;
            }
          } catch (error) {
            // Fall through to direct add when requestSubmit is blocked.
          }

          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          const cancelled = !this.form.dispatchEvent(submitEvent);
          if (cancelled || submitEvent.defaultPrevented) return;
        }

        this.addToCartDirect();
      }

      async addToCartDirect() {
        this.bindFormTargets();
        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');
        const variantId = variantInput?.value;
        if (!variantId || variantInput?.disabled) return;

        this.submitting = true;
        this.button.classList.add('loading');
        this.button.setAttribute('aria-disabled', 'true');

        try {
          const formData = new FormData(this.form);
          if (!formData.get('quantity')) formData.set('quantity', '1');

          const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          };
          config.headers = config.headers || {};
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', config);
          const data = await response.json();

          if (data.status) {
            this.productForm?.handleErrorMessage?.(data.description || data.message);
            return;
          }

          // Silent add: refresh cart badge only, never open cart.
          if (typeof this.productForm?.updateCartIconBubble === 'function') {
            this.productForm.updateCartIconBubble(data);
          } else if (data.sections?.['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              const doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const next =
                doc.getElementById('cart-icon-bubble') ||
                doc.querySelector('.shopify-section') ||
                doc.body.firstElementChild;
              if (next) bubble.innerHTML = next.innerHTML;
            }
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-sticky-cart-bar',
              productVariantId: variantId,
              cartData: data,
            });
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitting = false;
          this.button.classList.remove('loading');
          if (!this.mainSubmit?.disabled) {
            this.button.removeAttribute('aria-disabled');
            this.button.disabled = false;
          }
        }
      }

      syncFromMainSubmit() {
        if (!this.mainSubmit || !this.button) return;

        const disabled =
          this.mainSubmit.hasAttribute('disabled') || this.mainSubmit.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        this.button.toggleAttribute('aria-disabled', disabled);
        this.button.classList.toggle('loading', this.mainSubmit.classList.contains('loading'));

        if (!this.buttonLabel) return;

        const addLabel = this.buttonLabel.dataset.labelAdd || 'In den Warenkorb';
        const soldOutLabel = this.buttonLabel.dataset.labelSoldOut || 'Ausverkauft';
        const mainLabel = this.mainSubmit.querySelector('span:not(.loading__spinner):not(.sold-out-message)');
        const mainText = mainLabel?.textContent?.trim() || '';
        const isUnavailable =
          disabled &&
          mainText &&
          mainText !== (window.variantStrings?.addToCart || '') &&
          !/warenkorb/i.test(mainText);

        this.buttonLabel.textContent = isUnavailable ? mainText || soldOutLabel : addLabel;
      }
    }
  );
}
